import { computed } from 'vue';
import { useStore } from 'vuex';

const VAT_RATE = 1.25;

export function useVAT(orgName = null) {
  const store = useStore();
  
  const currentOrgName = computed(() => {
    if (orgName) return orgName;
    return store.state.organizations[0]?.orgName || null;
  });
  
  const showVAT = computed(() => {
    if (!currentOrgName.value) return false;
    return store.getters.getShowVAT(currentOrgName.value);
  });
  
  const applyVAT = (value, isSales = true) => {
    if (!value || !isSales || !showVAT.value) return value;
    return value * VAT_RATE;
  };
  
  const calculateRecommendedSalary = (revenue, salaryPercentage) => {
    return (revenue * salaryPercentage) / 100;
  };
  
  const calculateSalaryPercentage = (revenue, expenses) => {
    return revenue ? ((expenses / revenue) * 100) : 0;
  };
  
  const formatCurrency = (amount, isSales = true) => {
    const value = applyVAT(amount, isSales);
    return new Intl.NumberFormat('da-DK', {
      style: 'currency',
      currency: 'DKK',
      maximumFractionDigits: 0
    }).format(value);
  };
  
  const getVATLabel = () => {
    return showVAT.value ? '(inkl. moms)' : '(ekskl. moms)';
  };
  
  return {
    showVAT,
    applyVAT,
    calculateRecommendedSalary,
    calculateSalaryPercentage,
    formatCurrency,
    getVATLabel,
    VAT_RATE
  };
}
